import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d269fd8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "static" }
const _hoisted_2 = {
  loop: "",
  class: "audio",
  id: "static-player",
  volume: "0.2"
}
const _hoisted_3 = ["src"]

import { onBeforeMount, onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Static',
  setup(__props) {

onMounted(() => {
  const audioPlayer = document.getElementById('static-player') as HTMLAudioElement
  audioPlayer.play()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("audio", _hoisted_2, [
      _createElementVNode("source", {
        src: require(`@/assets/weather/static.ogg`)
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})